import { render } from "./EditarPost.vue?vue&type=template&id=c87ad464"
import script from "./EditarPost.vue?vue&type=script&lang=js"
export * from "./EditarPost.vue?vue&type=script&lang=js"

import "./EditarPost.vue?vue&type=style&index=0&id=c87ad464&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__